export default "__VITE_ASSET__e9efbf67__"